import { render, staticRenderFns } from "./ReviewView.vue?vue&type=template&id=2f3140d0"
import script from "./ReviewView.vue?vue&type=script&lang=js"
export * from "./ReviewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports